import { PaginationPayload } from 'app/shared/pagination/models';
import { RetrieveBlacklistsPayload } from 'app/modules/lists/requests';

const BASE = ['matchlists'] as const;

export const MATCHLIST_QUERY_KEYS = {
  getMatchlist: (id: number) => [...BASE, 'matchlist', id] as const,
  getMatchlists: (payload: RetrieveBlacklistsPayload) =>
    [...BASE, 'matchlists', payload] as const,
  getMatchlistContentAll: (id: number) =>
    [...BASE, 'matchlist-content', id] as const,
  getMatchlistContent: (id: number, payload: PaginationPayload) =>
    [...MATCHLIST_QUERY_KEYS.getMatchlistContentAll(id), payload] as const,
};
